import { render, staticRenderFns } from "./SalesTypeDropdownField.vue?vue&type=template&id=6b12bc39&scoped=true"
import script from "./SalesTypeDropdownField.vue?vue&type=script&lang=js"
export * from "./SalesTypeDropdownField.vue?vue&type=script&lang=js"
import style0 from "./SalesTypeDropdownField.vue?vue&type=style&index=0&id=6b12bc39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12bc39",
  null
  
)

export default component.exports